import { z } from 'zod';

/** Self-service profile edit (Settings › Hồ sơ). Name is the only editable field. */
export const updateProfileSchema = z.object({
  fullName: z.string().trim().min(1, 'Full name is required').max(100, 'Full name is too long'),
});

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

/**
 * Self-service password change. The current password is verified server-side
 * before the new hash is written, so it only needs to be non-empty here.
 */
export const changePasswordSchema = z.object({
  currentPassword: z.string().min(1, 'Current password is required'),
  newPassword: z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .max(200, 'Password is too long'),
});

export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
